import { createSlice } from '@reduxjs/toolkit'
import {
  fetchPvzScanLogs,
  fetchPvzParcelHistory,
  fetchPvzBalances,
} from './thunk'

const emptyList = () => ({
  data: [],
  totalPages: 1,
  totalElements: 0,
  isLoading: false,
  loaded: false,
  error: '',
})

const initialState = {
  scanLogs: emptyList(),
  parcelHistory: emptyList(),
  balances: emptyList(),
}

const onPending = (section) => {
  section.isLoading = true
  section.error = ''
}

const onFulfilled = (section, payload) => {
  section.isLoading = false
  section.loaded = true
  section.data = Array.isArray(payload?.data) ? payload.data : []
  section.totalPages = Math.max(1, payload?.totalPages ?? 1)
  section.totalElements = payload?.totalElements ?? section.data.length
}

const onRejected = (section, action) => {
  section.isLoading = false
  section.error = action.payload || action.error?.message || 'error'
}

const slice = createSlice({
  name: 'pvz',
  initialState,
  reducers: {
    // Reset a section (e.g. on page unmount) so re-entry shows the loading
    // state instead of the previously fetched rows.
    clearPvzSection(state, { payload }) {
      if (state[payload]) state[payload] = emptyList()
    },
  },
  extraReducers: {
    [fetchPvzScanLogs.pending]: (state) => onPending(state.scanLogs),
    [fetchPvzScanLogs.fulfilled]: (state, action) =>
      onFulfilled(state.scanLogs, action.payload),
    [fetchPvzScanLogs.rejected]: (state, action) =>
      onRejected(state.scanLogs, action),

    [fetchPvzParcelHistory.pending]: (state) => onPending(state.parcelHistory),
    [fetchPvzParcelHistory.fulfilled]: (state, action) =>
      onFulfilled(state.parcelHistory, action.payload),
    [fetchPvzParcelHistory.rejected]: (state, action) =>
      onRejected(state.parcelHistory, action),

    [fetchPvzBalances.pending]: (state) => onPending(state.balances),
    [fetchPvzBalances.fulfilled]: (state, action) =>
      onFulfilled(state.balances, action.payload),
    [fetchPvzBalances.rejected]: (state, action) =>
      onRejected(state.balances, action),
  },
})

export const { clearPvzSection } = slice.actions

export const reducer = slice.reducer
export const selectorPvzScanLogs = (state) => state.pvz.scanLogs
export const selectorPvzParcelHistory = (state) => state.pvz.parcelHistory
export const selectorPvzBalances = (state) => state.pvz.balances

export default slice
